'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var actions = {
  init: function init(context) {
    var _this = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var _JSON$parse, product, customer, _JSON$parse2, lenses, cms, buttons, variantId, variant, nonPrescriptionLens, tintsAndOptions;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _JSON$parse = JSON.parse(document.getElementById('ShopifyData').innerHTML), product = _JSON$parse.product, customer = _JSON$parse.customer;
              _JSON$parse2 = JSON.parse(document.getElementById('PrescriptionCMSData').innerHTML), lenses = _JSON$parse2.lenses, cms = _JSON$parse2.cms, buttons = _JSON$parse2.buttons;
              variantId = Number(document.querySelector('.js-variant-id').value);
              variant = product.variants.filter(function (variant) {
                return variant.id === variantId;
              })[0];
              nonPrescriptionLens = lenses.filter(function (lens) {
                return lens.tags.includes('no prescription');
              })[0];
              tintsAndOptions = {
                tints: [],
                options: []
              };

              buttons.map(function (button) {
                if (button.type === 'option') {
                  tintsAndOptions.options.push(button);
                } else if (button.type === 'tint') {
                  tintsAndOptions.tints.push(button);
                }
              });

              product.selectedVariant = variant;

              context.dispatch('getPrescriptions', customer);

              context.commit('setCms', cms);
              context.commit('setFrame', product);
              context.commit('setLenses', lenses);
              context.commit('setOptionMeta', tintsAndOptions);
              context.commit('setNonPrescriptionLens', nonPrescriptionLens);

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getPrescriptions: function getPrescriptions(context, customer) {
    if (Object.keys(customer).length > 0) {
      var mapPrescription = function mapPrescription(prescriptions) {
        var dataArrays = prescriptions.prescriptions_historical;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = dataArrays[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var prescription = _step.value;

            var lens = prescription.lens_name ? prescription.lens_name.split('-')[1].toUpperCase() : '';

            var object = {
              id: prescription.prescription_id || '',
              prescriptionSet: false,
              newPrescription: false,
              store: prescription.branch_name || '',
              date: prescription.order_date_created,
              type: prescription.prescription_purpose || '',
              left: { sph: prescription.sph_os, cyl: prescription.cyl_os, axis: prescription.axis_os, add: prescription.add_os, ipd: prescription.ipd_os, ph: prescription.ph_os },
              right: { sph: prescription.sph_od, cyl: prescription.cyl_od, axis: prescription.axis_od, add: prescription.add_od, ipd: prescription.ipd_od, ph: prescription.ph_od },
              frame: prescription.frame_name || '',
              lens: lens
            };

            data.push(object);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      };

      var email = customer.email;

      var data = [];
      var url = 'https://www.sunniessystems.com/api/3.0/324566/prescriptions/';
      var apiKey = '052398FSOWRI2UR7FHJKG789403JHFSA';
      var headers = {
        'oassis-api-key': apiKey
      };
      var params = {
        'email_address': email,
        'client_id': '95jgnvudiht03075kdhfrw256789dhif',
        'patient_id': ''
      };

      (0, _axios2.default)({
        url: url,
        method: 'get',
        headers: headers,
        params: params
      }).then(function (result) {
        mapPrescription(result.data);
        context.commit('setPastPrescriptions', data);
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
};

exports.default = actions;